<template>
  <base-edit :fields="isProvider ? adminFields : makerFields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template slot="images" slot-scope="{ input }">
      <ImageList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
      />
    </template>
    <template slot="email" slot-scope="{ input }">
      <div>{{input}}</div>
    </template>
  </base-edit>
</template>

<script>
  import TextList from '../../components/field/text-list';
  import ImageList from '../../components/field/images-list';
  import RadioField from '../../components/field/radio';

export default {
  components: {
    TextList,
    ImageList,
    RadioField
  },
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resourceName: "maker_administrators",
      adminFields: [
        {
          label: "メーカー",
          name: "maker_id",
          type: 'select',
          optionType: "common/makers",
          width: "60%"
        },
        {
          label: "メーカー管理者名",
          name: "name",
          rules: 'required|max:255',
          width: "60%"
        },
        {
          label: "メーカー管理者名(かな)",
          name: "name_kana",
          rules: "required|max:255|kana",
          width: "60%"
        },
        {
          label: "メーカー管理者メールアドレス",
          name: "email",
          type: "custom"
        }
      ],
      makerFields: [
        {
          label: "管理者名",
          name: "name",
          rules: 'required|max:255',
          width: "60%"
        },
        {
          label: "管理者名(かな)",
          name: "name_kana",
          rules: "required|max:255|kana",
          width: "60%"
        },
        {
          label: "管理者メールアドレス",
          name: "email",
          type: "custom"
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      if (this.isProvider) {
        return [
          {
            text: "メーカー管理者一覧",
            disabled: false,
            to: `/${this.resourceName}`
          },
          {
            text: "メーカー管理者編集",
            disabled: true
          }
        ];
      }
      else{
        return [
          {
            text: "担当者一覧",
            disabled: false,
            to: `/${this.resourceName}`
          },
          {
            text: "担当者編集",
            disabled: true
          }
        ];
      }
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  }

};
</script>
